import { useState } from 'react';
import styled from 'styled-components';

import Typography from '../Typography';

type AlertProps = {
  text: string;
  colorVariant?: string;
  color?: string;
};

type ContainerProps = {
  colorVariant: string;
  color: string | undefined;
  showAlert: boolean;
};

type CloseButtonProps = {
  onClick: () => void;
};

const defaultProps = {
  colorVariant: null,
  color: null,
};

interface Dictionary {
  [index: string]: string;
}

const getColor = (
  colorVariant: string,
  colors: Dictionary,
  color?: string
): string => {
  if (color) return color;
  return colors[colorVariant];
};

const AlertContainer = styled.div<ContainerProps>`
  display: ${(props): string => (props.showAlert ? 'flex' : 'none')};
  justify-content: space-between;
  position: fixed;
  width: 50%;
  z-index: 1;
  background-color: ${(props): string =>
    getColor(props.colorVariant, props.theme.colors, props.color)};
  border-radius: 0.25rem;
  padding: 1.5rem;
  @media ${({ theme }): string => theme.devices.laptop} {
    width: 52.5rem;
    height: 4.313rem;
  }
`;

const CloseButton = styled.div<CloseButtonProps>`
  margin-top: -1.3rem;
  margin-right: -0.8rem;
  cursor: pointer;
`;

const Alert = (props: AlertProps): JSX.Element => {
  const { text, colorVariant, color } = props;
  const [showAlert, setShowAlert] = useState(true);
  return (
    <AlertContainer
      colorVariant={colorVariant || 'gray35'}
      color={color}
      showAlert={showAlert}
      data-cy="alert"
    >
      <Typography type="body1" colorVariant="gray100">
        {text}
      </Typography>
      <CloseButton onClick={(): void => setShowAlert(false)}>
        <Typography type="buttons" colorVariant="gray50">
          x
        </Typography>
      </CloseButton>
    </AlertContainer>
  );
};

Alert.defaultProps = defaultProps;

export default Alert;
